import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { Form, Spinner } from 'react-bootstrap'
import { message } from 'antd'

import UserForm from './UserForm'

import { updateUser } from '../services'
import { handleError } from '../../../helpers'

export default function EditUserModal({ visible, onClose, user, reload }) {
	const [loading, setLoading] = useState(false)
	const { handleSubmit, register, formState: { errors } } = useForm({
		defaultValues: {
			name: user.name,
			document: user.document,
		}
	})

	const onSubmit = values => {
		setLoading(true)
		if(user.document === parseInt(values.document)) delete values.document
		if(!values.password) delete values.password

		updateUser(user.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Actualizar Usuario</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<UserForm
							register={register}
							errors={errors}
							onlyEditable
						/>
						<Button color="primary" type="submit" disabled={loading}>
							{ loading && <Spinner animation='border' size="sm" className='mr-5' /> }
							Actualizar Usuario
						</Button>						
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}